export default function FeatureSection() {
  const features = [
    {
      icon: 'ri-brain-line',
      title: 'Smart Spreadsheet Curation',
      desc: 'Every spreadsheet is hand-picked and verified by our curation team to ensure quality listings only.',
      image: 'https://readdy.ai/api/search-image?query=Minimalist%20modern%20workspace%20with%20sleek%20laptop%20displaying%20organized%20dashboard%20on%20light%20oak%20desk%2C%20editorial%20photography%2C%20soft%20morning%20sunlight%20from%20left%20side%2C%20clean%20scandinavian%20aesthetic%2C%20warm%20natural%20tones%2C%20productive%20calm%20atmosphere&width=500&height=350&seq=feature-smart-v2-026&orientation=landscape',
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Budget & Premium Options',
      desc: 'Find both affordable gems and premium-tier items across every category we track.',
      image: 'https://readdy.ai/api/search-image?query=Two%20stylish%20fashion%20items%20side%20by%20side%20one%20with%20budget%20tag%20and%20one%20premium%20on%20clean%20white%20surface%2C%20minimalist%20product%20comparison%20photography%2C%20soft%20balanced%20lighting%2C%20clean%20commercial%20aesthetic&width=350&height=350&seq=feature-budget-v2-027&orientation=squarish',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Verified Community Picks',
      desc: 'Top-rated items reviewed and vouched for by our active community of experienced hunters.',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20fashion%20accessories%20with%20a%20subtle%20verified%20checkmark%20on%20soft%20sage%20green%20backdrop%2C%20minimalist%20product%20photography%2C%20gentle%20diffused%20lighting%2C%20clean%20trustworthy%20aesthetic&width=350&height=350&seq=feature-verified-v2-028&orientation=squarish',
    },
    {
      icon: 'ri-refresh-line',
      title: 'Updated Weekly Listings',
      desc: 'Fresh content every week so you never miss trending items or newly discovered gems.',
    },
    {
      icon: 'ri-smartphone-line',
      title: 'Mobile Optimized Tables',
      desc: 'All spreadsheets are formatted for seamless viewing on any device, anywhere you go.',
    },
  ];

  return (
    <section id="features" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4 mb-14">
          <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 leading-tight">
            What Makes Our<br />Spreadsheets Different
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-md leading-relaxed lg:pt-3">
            We built pandabuyspreadsheet to be the most organized, transparent, and regularly updated resource for product discovery in 2026.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="md:col-span-2 bg-background-50 rounded-xl overflow-hidden flex flex-col">
            <div className="h-52 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20modern%20workspace%20with%20sleek%20laptop%20displaying%20organized%20dashboard%20on%20light%20oak%20desk%2C%20editorial%20photography%2C%20soft%20morning%20sunlight%20from%20left%20side%2C%20clean%20scandinavian%20aesthetic%2C%20warm%20natural%20tones%2C%20productive%20calm%20atmosphere&width=500&height=350&seq=feature-smart-v2-026&orientation=landscape"
                alt="Smart Spreadsheet Curation"
                title="pandabuy spreadsheet smart curation"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-6">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-3">
                <i className={`${features[0].icon} text-lg`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2">{features[0].title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{features[0].desc}</p>
            </div>
          </div>

          <div className="bg-background-50 rounded-xl p-6 flex flex-col justify-between">
            <div>
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-3">
                <i className={`${features[1].icon} text-lg`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2">{features[1].title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">{features[1].desc}</p>
            </div>
            <div className="h-40 overflow-hidden rounded-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Two%20stylish%20fashion%20items%20side%20by%20side%20one%20with%20budget%20tag%20and%20one%20premium%20on%20clean%20white%20surface%2C%20minimalist%20product%20comparison%20photography%2C%20soft%20balanced%20lighting%2C%20clean%20commercial%20aesthetic&width=350&height=350&seq=feature-budget-v2-027&orientation=squarish"
                alt="Budget and Premium Options"
                title="pandabuy spreadsheet budget finds"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="bg-background-50 rounded-xl p-6 flex flex-col justify-between">
            <div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2">{features[2].title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">{features[2].desc}</p>
            </div>
            <div className="h-40 overflow-hidden rounded-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20accessories%20with%20a%20subtle%20verified%20checkmark%20on%20soft%20sage%20green%20backdrop%2C%20minimalist%20product%20photography%2C%20gentle%20diffused%20lighting%2C%20clean%20trustworthy%20aesthetic&width=350&height=350&seq=feature-verified-v2-028&orientation=squarish"
                alt="Verified Community Picks"
                title="pandabuy spreadsheet verified picks"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-5">
            <div className="bg-background-50 rounded-xl p-6">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 mb-3">
                <i className={`${features[3].icon} text-lg`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2">{features[3].title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{features[3].desc}</p>
            </div>
            <div className="bg-background-50 rounded-xl p-6">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 mb-3">
                <i className={`${features[4].icon} text-lg`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2">{features[4].title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{features[4].desc}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}